module.exports = __webpack_public_path__ + "img/logoscriptorium.4b247fb8.png";